import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigManagerProperties } from './enums/config-manager-properties.enum';
import { IdleTimeoutService } from './services/idle-timeout.service';
import { ScrollbarService } from './services/scrollbar/scrollbar.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, OnDestroy {
  title: string;
  build: string;
  isProduction: boolean;
  isListView = true;

  private unsubscriber = new Subject<void>();

  constructor(
    private configManagerService: ConfigManagerService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private scrollbarService: ScrollbarService,
    private idleTimeoutService: IdleTimeoutService,
    private router: Router
  ) {
    iconRegistry.addSvgIcon('xpo-logo', sanitizer.bypassSecurityTrustResourceUrl('./assets/images/xpo_logo.svg'));

    const optypes = [0, 1, 2, 5, 7, 9, 10, 11, 12, 13, 17];
    optypes.forEach(optype => {
      iconRegistry.addSvgIcon(`optype_${optype}`, sanitizer.bypassSecurityTrustResourceUrl(`./assets/images/optype_${optype}.svg`));
    });

    this.title = configManagerService.getSetting<string>(ConfigManagerProperties.appName);
    this.build = configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion);

    this.isProduction = this.configManagerService.getSetting<boolean>('production');
  }

  ngOnInit() {
    this.scrollbarService.startWatcher();

    this.router.events.pipe(takeUntil(this.unsubscriber)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isListView = !_.startsWith(event['url'], '/view-payform') && !_.startsWith(event['url'], '/payform');
      }
    });
  }

  ngOnDestroy() {
    this.scrollbarService.stopWatcher();
    this.idleTimeoutService.stop();

    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
